import script from "./OrganizationsConnectionsSubOrganizationTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationsConnectionsSubOrganizationTable.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationsConnectionsSubOrganizationTable.vue?vue&type=style&index=0&id=e3d894ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3d894ac"]])

export default __exports__